<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <EngineGeocode />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import EngineGeocode from '@/components/settings/app-frotix-registers/enginegeocode/Add'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'EngineGeocodeView',
  components: {
    PageTitle,
    PageRowWrapper,
    EngineGeocode,
    LoadingPage
  }
}
</script>
